module.exports = __webpack_public_path__ + "static/media/20201121_215035_880_IMG_0965.444def51.jpg";